import { toast } from "svelte-sonner";

export async function copyToClipboard(
	text: string,
	toastMessage: string = "Link gekopieerd!"
) {
	try {
		if (navigator.clipboard && window.isSecureContext) {
			// Modern approach for secure contexts
			await navigator.clipboard.writeText(text);
		} else {
			// Use the 'out of viewport hidden text area' trick
			const textArea = document.createElement("textarea");
			textArea.value = text;

			// Move textarea out of the viewport so it's not visible
			textArea.style.position = "fixed";
			textArea.style.left = "-999999px";
			textArea.style.top = "0";
			textArea.style.pointerEvents = "none";
			textArea.style.opacity = "0";

			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();

			// Execute the copy command
			document.execCommand("copy");

			// Clean up
			document.body.removeChild(textArea);
		}
		// Show toast notification
		toast.success(toastMessage);
		return true;
	} catch (error) {
		console.error("Copy to clipboard failed:", error);
		toast.error("Kopiëren mislukt. Probeer het opnieuw.");
		return false;
	}
}
